import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'
import type FeatureControlService from 'teacher-ui-client/services/feature-control'
import { FeatureAccess } from 'teacher-ui-client/services/feature-control'

export default class QuickStartRoute extends Route {
  @service router!: RouterService
  @service contentfulClient!: ContentfulClientService
  @service featureControl!: FeatureControlService

  beforeModel() {
    if (!this.featureControl.canAccess(FeatureAccess.QuickStart)) {
      void this.router.replaceWith('subscription-type.home')
      return
    }
  }

  async model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute

    const quickStartResources = await this.contentfulClient.getQuickStartResources({ subscriptionType })
    return { quickStartResources }
  }
}
